<template>
  <section class="lg:pl-50 border-t mx-10">
    <div class="mt-3 flex items-center gap-x-3">
      <div
        @click="goBack"
        class="flex items-center border-main rounded-md md:rounded-lg shadow-xs w-20 gap-x-2 text-gray-90 lg:py-2 font-semibold text-fg-default text-xs cursor-pointer justify-center"
      >
        <i class="el-icon-back"></i>
        <p class="font-light text-xs">Back</p>
      </div>
      <div class="flex items-center gap-x-2">
        <p class="font-light text-sm">Api management</p>
        <span class="text-lg font-light text-gray-muted">
          <arrow-right-icon />
        </span>
        <p class="font-light text-sm">Customer</p>
      </div>
    </div>
    <div class="my-6 pb-4 lg:pb-0 border-b">
      <div
        class="flex lg:items-center items-start lg:flex-row flex-col gap-y-3 gap-x-6"
      >
        <div
          class="cursor-pointer pb-1 lg:pb-6 font-medium lg:text-13px text-xs max-w-xl"
          @click="goToActiveTab('customer-profile')"
          :class="activeClass('customer-profile')"
        >
          Profile
        </div>
        <div
          class="cursor-pointer text-fg-muted pb-1 lg:pb-6 font-medium lg:text-13px text-xs max-w-xl"
          @click="goToActiveTab('virtual-accounts')"
          :class="activeClass('virtual-accounts')"
        >
          Virtual Accounts
        </div>
        <button
          class="text-fg-muted pb-1 lg:pb-6 font-medium lg:text-13px text-xs max-w-xl border-0 outline-none"
          @click="goToActiveTab('transactions')"
          :class="activeClass('transactions')"
        >
          Transactions
        </button>
      </div>
    </div>
    <div v-if="isLoading">
      <div class="flex items-center justify-center w-full h-screen -mt-32">
        <spinner />
      </div>
    </div>
    <div v-else>
      <customer-profile v-if="isCustomerProfileActive" />
      <virtual-accounts v-if="isVirtualAccountActive" />
      <customer-transactions v-if="isTransactionsActive" />
    </div>
  </section>
</template>

<script>
import tenant from '@/mixins/tenant.js'
import getCustomers from '@/mixins/externalApi.js'

export default {
  mixins: [getCustomers, tenant],
  data () {
    return {
      activeTab: 'customer-profile',
      isLoading: false
    }
  },
  components: {
    ArrowRightIcon: () => import('@/assets/v2/icons/ArrowRightIcon.vue'),
    CustomerProfile: () =>
      import('@/components/v2/externalApi/views/customers/CustomerProfile.vue'),
    VirtualAccounts: () =>
      import('@/components/v2/externalApi/views/customers/VirtualAccounts.vue'),
    CustomerTransactions: () =>
      import(
        '@/components/v2/externalApi/views/customers/CustomerTransactions.vue'
      ),
    Spinner: () => import('@/components/v2/app/Spinner.vue')
  },
  methods: {
    goBack () {
      this.$router.go(-1)
    },
    activeClass (tab) {
      return this.activeTab === tab ? 'active-class' : ''
    },
    async getCustomerDetails () {
      const customerId = this.$route.params.id
      this.isLoading = true
      const vm = this
      await this.$store
        .dispatch('externalApi/getCustomerDetails', customerId)
        .then(() => {
          this.isLoading = false
        })
        .catch((error) => {
          this.isLoading = false
          this.handleErrorResponseNotification(error)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    goToActiveTab (tab) {
      this.activeTab = tab
    }
  },
  computed: {
    isTransactionsActive () {
      return this.activeTab === 'transactions'
    },
    isCustomerProfileActive () {
      return this.activeTab === 'customer-profile'
    },
    isVirtualAccountActive () {
      return this.activeTab === 'virtual-accounts'
    },
    currentCustomerDetails () {
      return this.$store.state.externalApi.customerDetails
    }
  },
  mounted () {
    this.getCustomerDetails()
  }
}
</script>
<style scoped>
.active-class {
  font-weight: 700;
  border-bottom: 1.5px solid var(--color-primary);
  @apply text-primary;
}
</style>
